<template>
  <div class="dashborad container">
    <div class="dashborad-left">
      <div class="common-title">
            2024年度累计概况
        </div>
        <div class="admin-stat-list">
          <div class="admin-stat-item">
            <el-card>
              <div class="admin-common-wrap">
                <div class="common-title">
                  总访问数
                </div>
                <div v-if="totalVisit" class="common-number">
                  <count-to :endVal="totalVisit"></count-to>
                </div>
              </div>
              <div class="chart-wrap">
                <div ref="visitRef" style="width: 100%; height: 450px"></div>
              </div>
            </el-card>
          </div>
          <div class="admin-stat-item">
            <el-card>
              <div class="admin-common-wrap">
                <div class="common-title">
                  总完善信息数
                </div>
                <div v-if="totalComplete" class="common-number">
                  <count-to :endVal="totalComplete"></count-to>
                </div>
              </div>
              <div class="chart-wrap">
                <div ref="addRef" style="width: 100%; height: 450px"></div>
              </div>
            </el-card>
          </div>
          <div class="admin-stat-item">
            <el-card>
              <div class="common-title">
                线上总销售
              </div>
              <div class="sale-data-list">
                <div class="sale-data-item" v-if="saleData.pay">
                  <div class="label">
                    已支付
                  </div>
                  <div class="num">
                    <div>概率 <span>{{ saleData.pay.probCount ? saleData.pay.probCount : '-' }}</span> 单</div>
                    <div>指南 <span>{{ saleData.pay.guideCount ?  saleData.pay.guideCount : '-'}}</span> 单</div>
                    <div>清单 <span>{{ saleData.pay.voluntaryListCount ? saleData.pay.voluntaryListCount : '-' }}</span> 单</div>
                  </div>
                </div>
                <div class="sale-data-item" v-if="saleData.close">
                  <div class="label">
                    已关闭
                  </div>
                  <div class="num">
                    <div>概率 <span>{{ saleData.close.probCount ? saleData.close.probCount : '-' }}</span> 单</div>
                    <div>指南 <span>{{ saleData.close.guideCount ? saleData.close.guideCount : '-' }}</span> 单</div>
                    <div>清单 <span>{{ saleData.close.voluntaryListCount ? saleData.close.voluntaryListCount : '-' }}</span> 单</div>
                  </div>
                </div>
                <div class="sale-data-item" v-if="saleData.refund">
                  <div class="label">
                    已作废
                  </div>
                  <div class="num">
                    <div>概率 <span>{{ saleData.refund.probCount ? saleData.refund.probCount : '-' }}</span> 单</div>
                    <div>指南 <span>{{ saleData.refund.guideCount ? saleData.refund.guideCount : '-' }}</span> 单</div>
                    <div>清单 <span>{{ saleData.refund.voluntaryListCount ? saleData.refund.voluntaryListCount : '-' }}</span> 单</div>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="admin-stat-item">
            <el-card>
              <div class="common-title">
                销售金额
              </div>
              <div class="total-item">
                {{ totalData }} 元
              </div>
            </el-card>
          </div>
          <div class="admin-stat-item">
            <el-card>
              <div class="common-title">
                正式激活码总激活量
              </div>
              <div class="code-total-list">
                <div v-for="(item, index) in codeData" :key="index" class="code-total-item">
                  <div class="label">
                    {{ item.cardName }}
                  </div>
                  <div class="num">
                    <span>{{ item.countNumber }}</span> 个
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
    </div>
    <div class="dashborad-main">
      <div class="part">
        <div class="part-top">
          <div class="common-title">
            数据概览
          </div>
          <div class="common-date">
            数据时间：{{ date.now }}
          </div>
        </div>
        <div class="part-content">
          <div class="num-list">
            <div class="num-item">
              <div class="label">今日访问数</div>
              <div class="num">
                <span v-if="!userStat.todayVisitCount">-</span>
                <countTo v-else :endVal='userStat.todayVisitCount' />
                人
              </div>
              <div class="change">
                较昨日
                {{ userStat.thanYesterdayVisitPercent }}
              </div>
            </div>
            <div class="num-item">
              <div class="label">今日完善信息数</div>
              <div class="num">
                <span v-if="!userStat.todayAddCount">-</span>
                <countTo v-else :endVal='userStat.todayAddCount' />人</div>
              <div class="change">较昨日 {{ userStat.thanYesterdayAddPercent }}</div>
            </div>
            <div class="num-item">
              <div class="label">今日线上销售情况</div>
              <div class="num">
                <template v-if="!saleStat.todayCount">-</template>
                <countTo v-else :endVal='saleStat.todayCount' />
                单
                <template v-if="saleStat.todayAmountCount">
                  (<countTo :endVal='saleStat.todayAmountCount' />元)
                </template>
              </div>
              <div class="change">较昨日 {{ saleStat.thanYesterdayAddPercent }}</div>
            </div>
            <div class="num-item">
              <div class="label">今日激活码激活数</div>
              <div class="num">
                <template v-if="!codeStat.todayCount">-</template>
                <countTo v-else :endVal='codeStat.todayCount' />个</div>
              <div class="change">较昨日 {{ codeStat.thanYesterdayAddPercent }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="part">
        <div class="chart-list">
          <div class="chart-item">
            <el-card>
              <div class="common-title">
                用户新增情况
              </div>
              <div class="common-date">
                数据时间：{{ date.start }} - {{ date.end }}
              </div>
              <div class="chart-line">
                <div class="chart-wrap">
                  <div ref="newUserRef" style="height: 300px; width: 100%"></div>
                </div>
                <div class="chart-rank">
                  <rank-filter :options="options" type="userAdd" title="用户新增前十渠道"></rank-filter>
                </div>
              </div>
            </el-card>
          </div>
          <div class="chart-item">
            <el-card>
              <div class="common-title">
                用户活跃情况
              </div>
              <div class="common-date">
                数据时间：{{ date.start }} - {{ date.end }}
              </div>
              <div class="chart-line">
                <div class="chart-wrap">
                  <div ref="activeUserRef" style="height: 300px; width: 100%"></div>
                </div>
                <div class="chart-rank">
                  <rank-filter :options="options" type="userActive" title="用户活跃前十渠道"></rank-filter>
                </div>
              </div>
            </el-card>
          </div>
          <div class="chart-item">
            <el-card>
              <div class="common-title">
                线上订单详情
              </div>
              <div class="common-date">
                数据时间：{{ date.start }} - {{ date.end }}
              </div>
              <div class="chart-line">
                <div class="chart-wrap">
                  <div ref="onlineOrderRef" style="height: 300px; width: 100%"></div>
                </div>
                <div class="chart-rank">
                  <rank-filter type="online" :options="onlineOptions" title="线上订单前十渠道" ></rank-filter>
                </div>
              </div>
            </el-card>
          </div>
          <div class="chart-item">
            <el-card>
              <div class="common-title">
                激活码激活情况
              </div>
              <div class="common-date">
                数据时间：{{ date.start }} - {{ date.end }}
              </div>
              <div class="chart-line">
                <div class="chart-wrap">
                  <div ref="activeCodeRef" style="height: 300px; width: 100%"></div>
                </div>
                <div class="chart-rank">
                  <rank-filter type="code" :options="codeOptions" title="激活码激活前十渠道" ></rank-filter>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import * as echarts from 'echarts'

import rankFilter from './RankFilter.vue'

// 微信图表样式
// import chartTheme from './theme2.json'

// 阿里图表样式
import chartTheme from './theme.json'

export default {
    components: {
        countTo,
        rankFilter
    },
    data() {
        return {
            saleData: {},
            totalData: '',
            date: {
                start: '',
                end: '',
                now: ''
            },
            codeData: [],
            totalVisit: 0,
            totalComplete: 0,
            userChartData: [],
            userActiveChartData: [],
            orderChartData: [],
            codeActiveData: [],
            options: [],
            onlineOptions: [
                { label: '概率已支付', value: '2-1' },
                { label: '概率已关闭', value: '2-2' },
                { label: '概率已退费', value: '2-3' },
                { label: '指南已支付', value: '1-1' },
                { label: '指南已关闭', value: '1-2' },
                { label: '指南已退费', value: '1-3' }
            ],
            codeOptions: [
                { label: '概率激活码已激活', value: '2-3' },
                { label: '概率激活码已作废', value: '2-4' },
                { label: '指南激活码已激活', value: '1-3' },
                { label: '指南激活码已作废', value: '1-4' }
            ],
            userStat: {},
            saleStat: {},
            codeStat: {},
            incomeStat: {}
        }
    },
    methods: {
        // 折线图
        setLineChart(refName, map) {
            const mapList = Object.keys(map)
            let xList = []
            const seriesList = mapList.map((v, index) => {
                if (index === 0) {
                    const tempItem = map[v]
                    xList = tempItem.map((v) => v.day)
                }
                xList.forEach((xValue) => {
                    const tempData = map[v].find((i) => i.day === xValue)
                    if (!tempData) {
                        // 补充天数
                        map[v].push({
                            day: xValue,
                            labelName: v,
                            count: 0
                        })
                    }
                })
                map[v] = map[v].sort((a, b) => {
                    return a.day.split('-')[2] - b.day.split('-')[2]
                })
                const data = map[v].map((v) => v.count)
                return {
                    name: v,
                    type: 'line',
                    smooth: true,
                    data
                }
            })
            const chartDom = this.$refs[refName]
            const myChart = echarts.init(chartDom, 'custom')
            const option = {
                xAxis: {
                    type: 'category',
                    data: xList,
                    boundaryGap: false
                },
                yAxis: {
                    type: 'value'
                },
                series: seriesList,
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: mapList,
                    right: 20,
                    icon: 'circle'
                },
                grid: {
                    top: 30,
                    right: 50,
                    bottom: 30,
                    left: 50
                }
            }
            myChart.setOption(option)
        },
        // 饼图
        setPieChart(refName, list) {
            const chartDom = this.$refs[refName]
            const myChart = echarts.init(chartDom, 'custom')
            const option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    left: 'center',
                    top: '20'
                },
                grid: {
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['14%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: list
                    }
                ]
            }
            myChart.setOption(option)
        },
        getData() {
            this.getVisitData()
            this.getAddData()
            this.getSaleData()
            this.getTotalData()
            this.getCodeData()
            this.getUserAddChart()
            this.getUserActiveChart()
            this.getOrderChart()
            this.getCodeActiveChart()
        },
        getVisitData() {
            this.$api.data.getVisitData().then((res) => {
                if (res.success) {
                    if (res.data && res.data.length) {
                        const obj = {}
                        res.data.forEach((v) => {
                            if (v.labelName) {
                                if (obj[v.labelName]) {
                                    obj[v.labelName] += v.userActiveCount
                                } else {
                                    obj[v.labelName] = v.userActiveCount
                                }
                                this.totalVisit += v.userActiveCount
                            }
                        })
                        const list = []
                        for (const i in obj) {
                            list.push({
                                name: i,
                                value: obj[i]
                            })
                        }
                        this.setPieChart('visitRef', list)
                    }
                }
            })
        },
        getAddData() {
            this.$api.data.getAddData().then((res) => {
                if (res.success) {
                    if (res.data && res.data.length) {
                        const obj = {}
                        res.data.forEach((v) => {
                            if (v.labelName) {
                                if (obj[v.labelName]) {
                                    obj[v.labelName] += v.completeCount
                                } else {
                                    obj[v.labelName] = v.completeCount
                                }
                            }
                            this.totalComplete += Number(v.completeCount)
                        })
                        const list = []
                        for (const i in obj) {
                            list.push({
                                name: i,
                                value: obj[i]
                            })
                        }
                        this.setPieChart('addRef', list)
                    }
                }
            })
        },
        getSaleData() {
            this.$api.data.getOrderData().then((res) => {
                if (res.success) {
                    this.saleData = res.data
                }
            })
        },
        getTotalData() {
            this.$api.data.getTotalData().then((res) => {
                if (res.success) {
                    this.totalData = res.data.totalAmountCount
                }
            })
        },
        getCodeData() {
            this.$api.data.getCodeData().then((res) => {
                if (res.success) {
                    this.codeData = res.data
                }
            })
        },
        getUserAddChart() {
            this.$api.data.getUserChartData().then((res) => {
                if (res.success) {
                    this.userChartData = res.data
                    const map = {}
                    res.data.forEach((v) => {
                        if (v.day) {
                            if (!this.date.start) {
                                this.date.start = v.day
                            } else {
                                const day1 = Number(v.day.split('-').join(''))
                                const day2 = Number(this.date.start.split('-').join(''))
                                if (day1 < day2) {
                                    this.date.start = v.day
                                }
                            }
                            if (!this.date.end) {
                                this.date.end = v.day
                            } else {
                                const day1 = Number(v.day.split('-').join(''))
                                const day2 = Number(this.date.end.split('-').join(''))
                                if (day1 > day2) {
                                    this.date.end = v.day
                                }
                            }
                        }
                        if (map[v.labelName]) {
                            const temp = map[v.labelName].find((i) => i.day === v.day)
                            if (temp) {
                                temp.count += v.allAddCount
                            } else {
                                map[v.labelName].push({
                                    ...v,
                                    count: v.allAddCount
                                })
                            }
                        } else {
                            map[v.labelName] = [{
                                ...v,
                                count: v.allAddCount
                            }]
                        }
                    })
                    this.setLineChart('newUserRef', map)
                }
            })
        },
        getUserActiveChart() {
            this.$api.data.getUserActiveData().then((res) => {
                if (res.success) {
                    this.userActiveChartData = res.data
                    const map = {}
                    res.data.forEach((v) => {
                        if (map[v.labelName]) {
                            const temp = map[v.labelName].find((i) => i.day === v.day)
                            if (temp) {
                                temp.count += v.userActiveCount
                            } else {
                                map[v.labelName].push({
                                    ...v,
                                    count: v.userActiveCount
                                })
                            }
                        } else {
                            map[v.labelName] = [{
                                ...v,
                                count: v.userActiveCount
                            }]
                        }
                    })
                    this.setLineChart('activeUserRef', map)
                }
            })
        },
        getOrderChart() {
            this.$api.data.getOrderChartData().then((res) => {
                if (res.success) {
                    const map = {}
                    res.data.forEach((v) => {
                        if (map[v.countName]) {
                            map[v.countName].push({
                                ...v,
                                count: v.countNumber
                            })
                        } else {
                            map[v.countName] = [{
                                ...v,
                                count: v.countNumber
                            }]
                        }
                    })
                    this.setLineChart('onlineOrderRef', map)
                }
            })
        },
        getCodeActiveChart() {
            this.$api.data.getCodeActiveChartData().then((res) => {
                if (res.success) {
                    this.codeActiveData = res.data
                    const map = {}
                    res.data.forEach((v) => {
                        if (map[v.countName]) {
                            map[v.countName].push({
                                ...v,
                                count: v.countNumber
                            })
                        } else {
                            map[v.countName] = [{
                                ...v,
                                count: v.countNumber
                            }]
                        }
                    })
                    this.setLineChart('activeCodeRef', map)
                }
            })
        },
        getStat() {
            this.getUserStat()
            this.getSaleStat()
            this.getCodeStat()
        },
        getUserStat() {
            this.$api.data.getUserStat().then((res) => {
                if (res.success) {
                    this.userStat = res.data
                }
            })
        },
        getSaleStat() {
            this.$api.data.getSaleStat().then((res) => {
                if (res.success) {
                    this.saleStat = res.data
                }
            })
        },
        getCodeStat() {
            this.$api.data.getCodeStat().then((res) => {
                if (res.success) {
                    this.codeStat = res.data
                    console.log(this.codeStat)
                }
            })
        },
        getFilter() {
            this.$api.data.getFilterData().then((res) => {
                console.log(2345, res)
                if (res.success) {
                    console.log(res.data)
                    this.options = res.data.map((v) => {
                        return {
                            label: v.labelName,
                            value: `${v.labelName}-${v.labelType}`
                        }
                    })
                }
            })
        },
        setDate() {
            const currentDate = new Date()

            const year = currentDate.getFullYear()
            const month = String(currentDate.getMonth() + 1).padStart(2, '0') // 注意月份需要加一，并进行补零操作
            const day = String(currentDate.getDate()).padStart(2, '0') // 需要补零操作

            const formattedDate = `${year}-${month}-${day}`
            this.date.now = formattedDate
        }
    },
    mounted() {
        this.getData()
        this.getStat()
        this.getFilter()
        this.setDate()
    },
    created() {
        // 注册主题
        echarts.registerTheme('custom', chartTheme)
    }
}
</script>

<style lang="less" scoped>
.sale-data-list {
  display: flex;
  .sale-data-item {
    flex: 1;
    border-radius: 10px;
    background-color: #14aaff;
    padding: 1em 0;
    color: #fff;
    .num {
      font-weight: 400;
      font-size: 1em;
      color: #fff;
      padding: 0;
      span {
        font-weight: 700;
      }
    }
    .label {
      font-size: 1.1em;
      font-weight: 700;
      margin-bottom: 10px;
    }
  }
  .sale-data-item + .sale-data-item {
    margin-left: 1em;
  }
}
.total-item {
  width: 100%;
  color: #fff;
  font-weight: 700;
  font-size: 1.8em;
  background-color: #14aaff;
  border-radius: 10px;
  padding: 1em 0;
}
.code-total-list {
  display: flex;
  .code-total-item {
    background-color: #14aaff;
    color: #fff;
    padding: 1em 0;
    border-radius: 10px;
    flex: 1;
    .num {
      font-weight: 400;
      font-size: 1em;
      margin-top: 0.5em;
      color: #fff;
      padding: 0;
    }
    span {
      font-weight: 700;
    }
  }
  .code-total-item + .code-total-item {
    margin-left: 1em;
  }
}
.chart-line {
  display: flex;
  .chart-wrap {
    flex: 1;
  }
  .chart-rank {
    flex: 0 0 250px;
    min-width: 250px;
  }
}
.common-date {
  margin-bottom: 1em;
}
.admin-common-wrap {
  display: flex;
  justify-content: space-between;
}
.common-number {
  font-weight: 700;
  font-size: 1.3em;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Manager/Sys/AdminDashboard.vue